
import { Button } from "@/components/ui/button";
import { ExternalLink, LogIn, Check } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";

const JoinMovementSection = () => {
  const navigate = useNavigate();
  
  const handleVerificationClick = () => {
    navigate('/verification-process', { state: { noRedirect: true } });
  };
  
  return (
    <section className="py-16 px-4 bg-gradient-to-r from-nation-purple/10 to-nation-teal/10 dark:from-nation-purple/30 dark:to-nation-teal/30 border-y border-gray-200 dark:border-gray-700">
      <div className="container mx-auto max-w-5xl">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold mb-2">
            Join the Movement
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Be part of the democratic revival in the Cayman Islands. Your voice
            matters!
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div>
            <h3 className="text-xl font-semibold mb-4">
              Why Join NationCard™?
            </h3>
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <div className="h-6 w-6 rounded-full bg-green-500 text-white flex items-center justify-center mr-2 flex-shrink-0">
                  <Check className="h-4 w-4" />
                </div>
                <span>Your voice directly influences public policy</span>
              </li>
              <li className="flex items-start">
                <div className="h-6 w-6 rounded-full bg-green-500 text-white flex items-center justify-center mr-2 flex-shrink-0">
                  <Check className="h-4 w-4" />
                </div>
                <span>Access data-driven insights on Cayman's key issues</span>
              </li>
              <li className="flex items-start">
                <div className="h-6 w-6 rounded-full bg-green-500 text-white flex items-center justify-center mr-2 flex-shrink-0">
                  <Check className="h-4 w-4" />
                </div>
                <span>Collaborate with fellow citizens on solutions</span>
              </li>
              <li className="flex items-start">
                <div className="h-6 w-6 rounded-full bg-green-500 text-white flex items-center justify-center mr-2 flex-shrink-0">
                  <Check className="h-4 w-4" />
                </div>
                <span>
                  Hold elected officials accountable between elections
                </span>
              </li>
            </ul>

            <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700">
              <p className="text-sm">
                <strong>Caymanians</strong> are joining the NationCard™
                movement, working together to build a better future.
              </p>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-800 p-8 rounded-lg shadow-md border border-gray-200 dark:border-gray-700">
            <div className="text-center">
              <h3 className="text-xl font-semibold mb-6">
                Become a Verified Pollster
              </h3>

              <p className="mb-6 text-muted-foreground">
                Getting verified is easy. Sign in or create an account, then
                complete your demographic profile and identity verification.
              </p>

              <div className="space-y-4">
                <Button
                  asChild
                  className="w-full bg-nation-purple hover:bg-nation-purple-dark text-white"
                >
                  <Link to="/auth">
                    <LogIn className="h-4 w-4 mr-2" />
                    Sign In / Create Account
                  </Link>
                </Button>

                <Button 
                  variant="outline" 
                  className="w-full"
                  onClick={handleVerificationClick}
                >
                  Learn About Verification Process
                  <ExternalLink className="h-4 w-4 ml-2" />
                </Button>
              </div>

              <div className="mt-6 pt-6 border-t border-gray-200 dark:border-gray-700">
                <p className="text-sm text-muted-foreground">
                  After signing in, visit your profile to complete the
                  verification process and start participating as a verified
                  pollster.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JoinMovementSection;
